var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlightEngine = function SvgHighlightEngine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M19.143 7.5h.714C21.041 7.5 22 8.507 22 9.75v6.75c0 1.243-.96 2.25-2.143 2.25h-.714c-.394 0-.714-.336-.714-.75v-2.25h-2.143V18c0 .829-.64 1.5-1.429 1.5H8.965c-.346 0-.68-.132-.94-.371l-1.966-1.806a1.53 1.53 0 0 1-.488-1.129V14.25H4.143v2.25c0 .414-.32.75-.714.75h-.715c-.394 0-.714-.336-.714-.75V9.75c0-.414.32-.75.714-.75h.715c.394 0 .714.336.714.75V12H5.57V9c0-.829.64-1.5 1.429-1.5h2.857V6H7c-.394 0-.714-.336-.714-.75V4.5c0-.414.32-.75.714-.75h7.857c.394 0 .714.336.714.75v.75c0 .414-.32.75-.714.75H12v1.5h2.857c.79 0 1.429.671 1.429 1.5v1.5h2.143V8.25c0-.414.32-.75.714-.75m-6.003 3h-2.336L9.5 13.845h1.328L9.623 16.5l3.517-3.91h-1.475z",
    clipRule: "evenodd"
  })));
};
export default SvgHighlightEngine;